import React from 'react';
import ReactModal from 'react-modal';

const Modal = (props) => {
  const { isOpen, onRequestClose, style, ariaHideApp, className, children } = props;
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={style}
      ariaHideApp={ariaHideApp}
      className={className}
    >
      {onRequestClose && (<button type="button" className="modal-close" onClick={onRequestClose} />) }
      <div className="modal-body justify-content-center">
        {children}
      </div>
    </ReactModal>
  );
};

export default Modal;
